import React, { useState } from 'react';
import Pagination from '../../Common/Pagination';

export default function SiteRainLogsCalendar({ logTypeName, logs, hide, onPrint }) {
    const dateFormatter = new Intl.DateTimeFormat('en-US', { day: "2-digit", month: "2-digit", year: "numeric" });
    const dateHourFormatter = new Intl.DateTimeFormat('en-US', { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false });
    const [isClosed, setIsClosed] = useState(false);
    const [selectedPage, setSelectedPage] = useState(1);
    const defaultPageSize = 30;
    const [pageSize, setPageSize] = useState(defaultPageSize);

    function handleSelectPage(pageNum) {
        setSelectedPage(pageNum);
    }

    let noItems = logs?.length === 0 && (<div className="centeredMessage"><h5>No Rain Logs available.</h5></div>);

    let shownLogs = logs.slice((pageSize * selectedPage) - pageSize, (pageSize * selectedPage));
    let shownStartIndex = (pageSize * selectedPage) - pageSize;
    let shownEndIndex = (pageSize * selectedPage);

    let logListItems = !isClosed && logs && logs
        .map((log, index) => <tr className={index < shownStartIndex || index >= shownEndIndex ? "hidden" : ""} key={log.date}>
            <td className="tabular-nums">{log.date && dateFormatter.format(new Date(log.date))}</td>
            <td>{log.rainfallTotal}</td>
            <td>{log.rainfallDuration}</td>
            <td>{log.stormId}</td>
            <td>{log.station}</td>
            <td className="smallScreen">
                <div className="log">
                    {log.date && (<div>
                        <span className="fieldDesc">Date:</span>
                        <span className="whitespace-nowrap">{log.date && dateFormatter.format(new Date(log.date))}</span>
                    </div>)}
                    {log.rainfallTotal !== undefined && (<div>
                        <span className="fieldDesc">Rainfall Total:</span>
                        {log.rainfallTotal}
                    </div>)}
                    {log.rainfallDuration !== undefined && (<div>
                        <span className="fieldDesc">Rainfall Duration:</span>
                        {log.rainfallDuration}
                    </div>)}
                    {log.stormId !== undefined && (<div>
                        <span className="fieldDesc">Storm ID:</span>
                        {log.stormId}
                    </div>)}
                    {log.station !== undefined && (<div>
                        <span className="fieldDesc">Station:</span>
                        {log.station}
                    </div>)}
                </div>
            </td>
        </tr>);

    if (selectedPage > 1 && (pageSize * selectedPage) - logListItems.length > 0) {
        let emptyRows = Array.from(
            { length: (pageSize * selectedPage) - logListItems.length },
            (cv, i) => (<tr className="noBkg noPrint" key={`R${i}`}><td>&nbsp;</td></tr>));
        logListItems = logListItems.concat(emptyRows);
    }

    let printButton = (<button onClick={() => onPrint("Rain Logs", "#rainLogs")}>Print</button>);

    let logList = logListItems.length === 0 ? undefined : !isClosed && (<>
        <table id="rainLogs" className="itemList">
            <thead>
                <tr>
                    <th className="date">Date</th>
                    <th className="date">Rainfall Total</th>
                    <th className="date">Rainfall Duration</th>
                    <th className="date">Storm ID</th>
                    <th className="date">Station</th>
                </tr>
            </thead>
            <tbody>{logListItems}</tbody>
        </table>
        <Pagination itemCount={logs.length} pageSize={pageSize} selectedPage={selectedPage} hideWhenSinglePage={false} onSelectPage={handleSelectPage}>
            {printButton}
        </Pagination>
    </>);

    //let selectLogType = onSelectLogType && (<span className="select" onClick={() => onSelectLogType()}><i className={logTypeSelected ? "dhicon-check-2" : "dhicon-check-empty"} /></span>);
    let selectLogType;

    let iconClass = isClosed ? "dhicon-right-open-2" : "dhicon-down-open-4";
    //let openClose = (<i className={`icon ${iconClass}`} onClick={() => setIsClosed(!isClosed)} />);
    let openClose;

    let showAllOption = //logs?.length > defaultPageSize &&
        (<option value={logs.length}>All</option>);
    let showFilter = logs?.length > 0 && (<div className="text-base content-end">
        <span>Show</span>
        <select className="bg-drhPalette-light mx-1 pl-1" onChange={(e) => setPageSize(e.target.value)} value={pageSize}>
            <option value={defaultPageSize}>{defaultPageSize}</option>
            {showAllOption}
        </select>
        <span>entries</span>
    </div>);

    let logTypeNameDescription = (<div className="text-drhPalette-primary text-xl font-bold pt-3 pb-1 flex justify-between">
        <span>{logTypeName}</span>
        {showFilter}
    </div>);

    let hideClass = hide && "hidden"

    return (
        <div className={`logTypeContainer rainLogs ${hideClass}`}>
            {logTypeNameDescription}
            {logList}
            {noItems}
        </div>
    );
}